import { render, staticRenderFns } from "./RadioComponent.vue?vue&type=template&id=2ffe870c&"
import script from "./RadioComponent.vue?vue&type=script&lang=ts&"
export * from "./RadioComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ffe870c')) {
      api.createRecord('2ffe870c', component.options)
    } else {
      api.reload('2ffe870c', component.options)
    }
    module.hot.accept("./RadioComponent.vue?vue&type=template&id=2ffe870c&", function () {
      api.rerender('2ffe870c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Elements/RadioComponent.vue"
export default component.exports